module.exports = __webpack_public_path__ + "img/btn.af8ca167.webp";